// src/components/home/AnnouncementNoticeModal.jsx
import React from "react";
import { FaTimes, FaRocket, FaProductHunt, FaCheckCircle } from "react-icons/fa";
import "./AnnouncementNoticeModal.css";

const AnnouncementNoticeModal = ({ isOpen, onClose, noticeType }) => {
  if (!isOpen) return null;

  return (
    <div className="bvh-notice-modal-overlay">
      <div className="bvh-notice-paper">
        {/* Official Notice Top Bar */}
        <div className="bvh-notice-top-bar">
          <div className="bvh-notice-official-stamp">
            <span className="bvh-stamp-text">OFFICIAL NOTICE</span>
          </div>
          <button className="bvh-notice-paper-close" onClick={onClose} title="Close notice">
            <FaTimes />
          </button>
        </div>

        {/* Notice Content Paper Body */}
        <div className="bvh-notice-paper-body">
          <div className="bvh-notice-doc-header">
            <h4 className="bvh-doc-sub">BODHAI ANNOUNCEMENT BULLETIN</h4>
            <span className="bvh-doc-date">DATE: JULY 2026</span>
          </div>

          <hr className="bvh-doc-divider" />

          {noticeType === "beta" ? (
            <>
              <h2 className="bvh-notice-paper-title">
                🎉 BODHAI V2 BETA IS OFFICIALLY LIVE
              </h2>
              <p className="bvh-notice-paper-text">
                This is an official announcement to inform all students, educators, and developers that <strong>BodhAI V2 Beta</strong> is now publicly accessible.
              </p>
              <p className="bvh-notice-paper-text">
                The updated platform introduces our high-speed compiler engine, real-time analytics, React 19 UI performance, and automated AI test generation.
              </p>

              <div className="bvh-notice-spec-box">
                <div className="bvh-spec-item"><FaCheckCircle /> Smarter AI Engine</div>
                <div className="bvh-spec-item"><FaCheckCircle /> Real-Time Judge0 Compiler</div>
                <div className="bvh-spec-item"><FaCheckCircle /> Proctored Assessment Engine</div>
              </div>

              <div className="bvh-notice-signature-block">
                <div className="bvh-signature-line">
                  <span className="bvh-signature-script">BodhAI</span>
                  <div className="bvh-signature-seal">OFFICIAL SEAL</div>
                </div>
                <div className="bvh-signature-meta">
                  <strong>BodhAI</strong> — Authorized Team<br />
                  <span>BodhAI Platform</span>
                </div>
              </div>

              <div className="bvh-notice-paper-footer">
                <a
                  href="https://betav2.bodhai.pages.dev/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bvh-notice-direct-link"
                  onClick={onClose}
                >
                  <FaRocket style={{ fontSize: "1rem", color: "#4f46e5" }} /> Open BodhAI V2 Beta (https://betav2.bodhai.pages.dev/)
                </a>
              </div>
            </>
          ) : (
            <>
              <h2 className="bvh-notice-paper-title">
                🚀 FEATURED LAUNCH ON PRODUCT HUNT
              </h2>
              <p className="bvh-notice-paper-text">
                We are proud to announce that <strong>BodhAI</strong> is featured on Product Hunt today!
              </p>
              <p className="bvh-notice-paper-text">
                Every upvote, comment, and review directly supports student developers worldwide and accelerates our AI-driven learning tools.
              </p>

              <div className="bvh-notice-spec-box">
                <div className="bvh-spec-item"><FaCheckCircle /> Product of the Day</div>
                <div className="bvh-spec-item"><FaCheckCircle /> Global Creator Community</div>
              </div>

              <div className="bvh-notice-signature-block">
                <div className="bvh-signature-line">
                  <span className="bvh-signature-script">BodhAI</span>
                  <div className="bvh-signature-seal">OFFICIAL SEAL</div>
                </div>
                <div className="bvh-signature-meta">
                  <strong>BodhAI</strong> — Authorized Team<br />
                  <span>BodhAI Platform</span>
                </div>
              </div>

              <div className="bvh-notice-paper-footer">
                <a
                  href="https://www.producthunt.com/products/bodhai?utm_source=bodhai.pages.dev&utm_medium=referral&utm_campaign=bodhai_product_launch_july_2026&utm_content=visit_producthunt_from_bodhai_homepage&utm_term=ai_learning_tool_launch"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bvh-notice-direct-link ph"
                  onClick={onClose}
                >
                  <FaProductHunt style={{ fontSize: "1.1rem", color: "#da552f" }} /> Open Product Hunt Page (producthunt.com/products/bodhai) ↗
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(AnnouncementNoticeModal);
